import {Record, List} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import type * as Models from './models';

export class ListsOverviewState extends Record<{
    isFetching: boolean;
    lists: {
        saved: List<Models.SavedList>;
        preset: List<Models.PresetList>;
    };
}>({
    isFetching: false,
    lists: {
        saved: List(),
        preset: List(),
    },
}) {}

export default makeReducer<ListsOverviewState>(
    [
        match(Actions.fetchLists, state =>
            state.merge({
                isFetching: true,
            }),
        ),
        match(Actions.fetchListsSuccess, (state, {payload}) =>
            state.merge({
                isFetching: false,
                lists: payload.lists,
            }),
        ),
        match(Actions.fetchListsFailed, state =>
            state.merge({
                isFetching: false,
            }),
        ),
        match(Actions.deleteListSuccess, (state, {payload}) =>
            state.merge({
                lists: {
                    saved: state.lists.saved.filter(list => list.id !== payload.listId),
                    preset: state.lists.preset,
                },
            }),
        ),
    ],
    new ListsOverviewState(),
);
